// Classroom color theming — shared by the director's Team Schedule and the
// staff-facing schedule so both color-code shifts by classroom identically.
//
// The authoritative color per room lives in the DB (`classrooms.color`,
// served by GET /api/classrooms). This module is only the name→Tailwind
// translation layer.

export const COLOR_TO_TW = {
  gray:   { bar: 'bg-gray-500',   head: 'bg-gray-200 border-gray-400',     pill: 'bg-gray-200 text-gray-800' },
  blue:   { bar: 'bg-blue-600',   head: 'bg-blue-200 border-blue-400',     pill: 'bg-blue-200 text-blue-900' },
  orange: { bar: 'bg-orange-600', head: 'bg-orange-300 border-orange-500', pill: 'bg-orange-200 text-orange-900' },
  yellow: { bar: 'bg-yellow-500', head: 'bg-yellow-300 border-yellow-500', pill: 'bg-yellow-200 text-yellow-900' },
  green:  { bar: 'bg-green-600',  head: 'bg-green-300 border-green-500',   pill: 'bg-green-200 text-green-900' },
  pink:   { bar: 'bg-pink-600',   head: 'bg-pink-300 border-pink-500',     pill: 'bg-pink-200 text-pink-900' },
  cyan:   { bar: 'bg-cyan-600',   head: 'bg-cyan-300 border-cyan-500',     pill: 'bg-cyan-200 text-cyan-900' },
  purple: { bar: 'bg-purple-600', head: 'bg-purple-300 border-purple-500', pill: 'bg-purple-200 text-purple-900' },
  red:    { bar: 'bg-red-600',    head: 'bg-red-300 border-red-500',       pill: 'bg-red-200 text-red-900' },
  slate:  { bar: 'bg-slate-500',  head: 'bg-slate-200 border-slate-400',   pill: 'bg-slate-200 text-slate-800' },
};

export const UNASSIGNED_THEME = { bar: 'bg-amber-500', head: 'bg-amber-200 border-amber-400', pill: 'bg-amber-200 text-amber-900' };
export const FALLBACK_THEME   = { bar: 'bg-gray-400',  head: 'bg-gray-100 border-gray-300',   pill: 'bg-gray-200 text-gray-700' };

export function themeForRoom(roomName, classrooms) {
  if (roomName === 'Unassigned') return UNASSIGNED_THEME;
  const c = (classrooms || []).find((c) => c.name === roomName);
  if (!c) return FALLBACK_THEME;
  return COLOR_TO_TW[c.color] || FALLBACK_THEME;
}

// Sort rooms by classrooms.display_order; "Unassigned" first; unknown rooms last.
export function sortRooms(roomNames, classrooms) {
  return [...roomNames].sort((a, b) => {
    if (a === 'Unassigned') return -1;
    if (b === 'Unassigned') return 1;
    const ca = (classrooms || []).find((c) => c.name === a);
    const cb = (classrooms || []).find((c) => c.name === b);
    if (!ca && !cb) return a.localeCompare(b);
    if (!ca) return 1;
    if (!cb) return -1;
    return ca.display_order - cb.display_order;
  });
}
